// @core/api/endpoints/billing/get_journal_entry.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetJournalEntryResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Get journal entry by ID
 * Retrieves a journal entry by its unique identifier. Returns the entry header and all associated debit and credit lines.
 */
export async function GetJournalEntry(
  id: string,
  options?: RequestOptions
): Promise<GetJournalEntryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/journal-entries/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.get<GetJournalEntryResponse>(requestPath, { ...requestOptions });
}
